import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
export function Footer() {
  const quickLinks = [{
    label: 'Accueil',
    path: '/'
  }, {
    label: 'À propos',
    path: '/a-propos'
  }, {
    label: 'Adhérents',
    path: '/adherents'
  }, {
    label: 'Événements',
    path: '/events'
  }, {
    label: 'Blog',
    path: '/blog'
  }, {
    label: 'Contact',
    path: '/contact'
  }];
  return <footer className="bg-arwm-white border-t border-gray-200" data-id="element-29">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-30">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-31">
          {/* Contact Info */}
          <div data-id="element-32">
            <h3 className="font-cormorant text-2xl font-bold text-arwm-maroon mb-6" data-id="element-33">
              Nous Contacter
            </h3>
            <div className="space-y-4 font-josefin text-arwm-dark-text" data-id="element-34">
              <div className="flex items-start space-x-3" data-id="element-35">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" data-id="element-36" />
                <a href="mailto:arestaurateursmarrakech@gmail.com" className="hover:text-arwm-maroon transition-colors" data-id="element-37">
                  arestaurateursmarrakech@gmail.com
                </a>
              </div>
              <div className="flex items-start space-x-3" data-id="element-38">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" data-id="element-39" />
                <a href="tel:+212660626515" className="hover:text-arwm-maroon transition-colors" data-id="element-40">
                  06 60 62 65 15
                </a>
              </div>
              <div className="flex items-start space-x-3" data-id="element-41">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" data-id="element-42" />
                <span data-id="element-43">68 rue Yougoslavie, Guéliz, Marrakech</span>
              </div>
            </div>
          </div>

          {/* Logo & Social */}
          <div className="flex flex-col items-center" data-id="element-44">
            <div className="mb-6" data-id="element-45">
              <img src="https://cdn.magicpatterns.com/uploads/a4uCYUHs7GFxaJeXiCw9Gk/694bca615babcc4e4abf88c3_Gemini_Generated_Image_qiw702qiw702qiw7_(1)-p-1600.png" alt="ARWM - Association des Restaurateurs de la Wilaya de Marrakech" className="h-24 w-auto" data-id="element-46" />
            </div>
            <div className="flex space-x-4" data-id="element-47">
              <a href="https://www.instagram.com/arwm_restaurantsmarrakechsafi/" target="_blank" rel="noopener noreferrer" className="text-arwm-dark-text hover:text-arwm-maroon transition-colors" aria-label="Instagram" data-id="element-48">
                <Instagram className="w-6 h-6" data-id="element-49" />
              </a>
              <a href="https://www.facebook.com/p/ARWM-association-des-restaurants-MarrakechSafi-100078122959170/" target="_blank" rel="noopener noreferrer" className="text-arwm-dark-text hover:text-arwm-maroon transition-colors" aria-label="Facebook" data-id="element-50">
                <Facebook className="w-6 h-6" data-id="element-51" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-52">
            <h3 className="font-cormorant text-2xl font-bold text-arwm-maroon mb-6" data-id="element-53">
              En Un Clic
            </h3>
            <ul className="space-y-3 font-josefin text-arwm-dark-text" data-id="element-54">
              {quickLinks.map(link => <li key={link.path} data-id="element-55">
                  <Link to={link.path} className="hover:text-arwm-maroon transition-colors" data-id="element-56">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-200 text-center" data-id="element-57">
          <p className="font-josefin text-sm text-arwm-dark-text" data-id="element-58">
            © 2024 ARWM — Tous Droits Réservés
          </p>
        </div>
      </div>
    </footer>;
}